module.exports = "#content{\r\n  width: 100%;\r\n}\r\n#content_news {\r\n  max-width: 1440px;\r\n  margin: auto;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/content/content.component.css
// module id = ./src/app/components/content/content.component.css
// module chunks = main